module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-box",
    style: ({
      'height': _vm.getHeight
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNoMore),
      expression: "!isNoMore"
    }],
    staticClass: "loading"
  }, [_vm._t("loading", [_vm._v(_vm._s(_vm.loadingText))])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNoMore),
      expression: "isNoMore"
    }],
    staticClass: "nomore"
  }, [_vm._t("nomore", [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('p', {
    staticClass: "nomore-text"
  }, [_vm._v(_vm._s(_vm.noMoreText))])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4cd1f548"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combo/loading.vue
// module id = 600
// module chunks = 1